import { Box, useTheme, Tab, Tabs, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import UserTable from '../../components/Tables/UserTable';
import { useQuery } from '@apollo/client';
import { GET_PTO_SPEND } from '../../graphql/reports/queries/getPtoSpend';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/text/Header';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const StyledTab = styled(Tab)({
  fontSize: '1rem',
  padding: '0.5rem',
  minWidth: 'auto',
});

const Textbox = styled(Typography)(() => ({
  margin: '0 auto',
  fontSize: '1rem',
  width: '91%',
  marginTop: '1rem',
  textAlign: 'left',
}));

const PtoSpend: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { caxyGreen } = theme.colors;
  const { data, loading, error } = useQuery(GET_PTO_SPEND);

  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (error) {
      navigate(`/404`);
    }
  }, [error, navigate]);

  if (loading) return <></>;

  const { high = [], ideal = [], low = [] } = data?.getUsersPtoSpend || {};

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '2rem',
        marginX: '0.5rem',
        marginBottom: '2rem',
        paddingX: '1rem',
        paddingBottom: '0.5rem',
        backgroundColor: 'white',
        boxShadow: '1rem 1rem 2rem #00000033',
        borderRadius: '0.3rem',
        '@media (min-width: 20rem)': {
          width: '17rem',
        },
        '@media (min-width: 28rem)': {
          width: '25rem',
        },
        '@media (min-width: 37.5rem)': {
          width: '28rem',
        },
        '@media (min-width: 43.75rem)': {
          width: '40rem',
        },
      }}
    >
      <Header sx={{ paddingTop: '1rem', width: '91%', margin: '0 auto' }}>PTO Spend</Header>
      <Textbox>
        This report measures the ratio between a user&apos;s front-loaded PTO remaining and the
        number of days until their Caxyversary. See table below for High, Ideal, and Low Spenders.
      </Textbox>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: caxyGreen,
          },
          '& .Mui-selected': {
            color: 'black',
          },
          marginTop: '.5rem',
          '@media (min-width: 20rem)': {
            marginLeft: '0.9rem',
          },
          '@media (min-width: 28rem)': {
            marginLeft: '1.3rem',
          },
          '@media (min-width: 37.5rem)': {
            marginLeft: '1.4rem',
          },
          '@media (min-width: 43.75rem)': {
            marginLeft: '2rem',
          },
        }}
      >
        <StyledTab label='High' />
        <StyledTab label='Ideal' />
        <StyledTab label='Low' />
      </Tabs>
      <CustomTabPanel value={activeTab} index={0}>
        <UserTable data={high} type={'High'} />
      </CustomTabPanel>

      <CustomTabPanel value={activeTab} index={1}>
        <UserTable data={ideal} type={'Ideal'} />
      </CustomTabPanel>

      <CustomTabPanel value={activeTab} index={2}>
        <UserTable data={low} type={'Low'} />
      </CustomTabPanel>
    </Box>
  );
};

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default PtoSpend;
